import * as THREE from "three";

import React, { useRef, useState } from "react";
import useStore from "../store";
import { useSphere } from "use-cannon";

// 3D Objects
import Player from "./Player.js";
import Globe from "./Globe.js";
import Model from "./Model.js";

import { sphericalToCartesian } from "../util/position";
import { models } from "../objects.json";

const Scene = () => {
  const { globeRadius } = useStore((state) => state.mutation);
  const [globeRef] = useSphere(() => ({
    mass: 0,
    position: [0, 0, 0],
    args: globeRadius,
  }));

  return (
    <>
      <Player position={[0, 0, globeRadius + 1]} globeRef={globeRef} />
      <Globe ref={globeRef} />
      {Object.entries(models).map(([id, config]) => {
        return <Model {...config} key={id} />;
      })}
    </>
  );
};

export default Scene;
